// Contact section constants

const ContactUs = [
  {
    id: 1,
    imageUrl: "/contact/phone.png",
    title: "Phone",
    details: "+92 315 8786614",
    link: "https://wa.me/923158786614",
  },
  {
    id: 2,
    imageUrl: "/contact/location.png",
    title: "Address",
    details: "Karachi, Pakistan",
  },
  {
    id: 3,
    imageUrl: "/contact/email.png",
    title: "Email",
    details: "hmtechnologies.work@gmail.com",
    link: "mailto:hmtechnologies.work@gmail.com",
  },
  {
    id: 4,
    imageUrl: "/contact/linkedin.png",
    title: "LinkedIn",
    details: "Hamza Mehboob",
    link: "https://www.linkedin.com/in/hamza-mehboob-843815233/",
  },
  {
    id: 5,
    imageUrl: "/contact/upwork.png",
    title: "Upwork",
    details: "Hire Me on Upwork",
    link: "https://www.upwork.com/freelancers/~01efd5ce631be90f37",
  },
  {
    id: 6,
    imageUrl: "/contact/fiverr.png",
    title: "Fiverr",
    details: "Order on Fiverr",
    link: "https://www.fiverr.com/hamzaamehboob",
  },
  {
    id: 7,
    imageUrl: "/contact/github.png",
    title: "GitHub",
    details: "View My Code",
    link: "https://github.com/hamxamehboob",
  },
];

const servicesDataHome = [
  {
    id: 1,
    imageUrl: "/services/logo.png",
    title: "Custom Web Development",
    description:
      "Modern, responsive web applications built with React, Next.js, and MERN stack for optimal performance.",
  },
  {
    id: 4,
    imageUrl: "/services/logo.png",
    title: "Native & Cross-Platform",
    description:
      "High-quality mobile apps for iOS, Android, or both using React Native and Flutter.",
  },
  {
    id: 7,
    imageUrl: "/services/logo.png",
    title: "Full-Stack Solutions",
    description:
      "Complete end-to-end development from database design to user interface for web and mobile platforms.",
  }
];


const servicesData = [
  {
    id: 4,
    imageUrl: "/services/logo.png",
    title: "Native & Cross-Platform Mobile Apps",
    description:
      "iOS and Android apps in Flutter and React Native, from onboarding and payments to live features, published on both stores.",
  },
  {
    id: 1,
    imageUrl: "/services/logo.png",
    title: "Custom Web Development",
    description:
      "Fast, responsive websites and web applications built with React, Next.js and the MERN stack.",
  },
  {
    id: 8,
    imageUrl: "/services/logo.png",
    title: "Admin Dashboards & CRM Web Apps",
    description:
      "Back-office tools that run a business day to day: dashboards, CRMs, moderation and reporting on the same API as your app.",
  },
  {
    id: 7,
    imageUrl: "/services/logo.png",
    title: "API Development & Integration",
    description:
      "Node.js, Express and Fastify APIs on MongoDB or PostgreSQL, plus payments, auth, push and third-party integrations.",
  },
  {
    id: 3,
    imageUrl: "/services/logo.png",
    title: "E-Commerce Solutions",
    description: "High-performance online stores with seamless payment integration and user-friendly design.",
  },
  {
    id: 6,
    imageUrl: "/services/logo.png",
    title: "App Store Deployment",
    description:
      "End-to-end publishing to the App Store and Google Play, with review fixes, updates and ongoing releases.",
  },
  {
    id: 5,
    imageUrl: "/services/logo.png",
    title: "Mobile UI/UX Design",
    description:
      "Intuitive, engaging mobile experiences designed in Figma and built pixel-exact.",
  },
  {
    id: 2,
    imageUrl: "/services/logo.png",
    title: "Progressive Web Apps",
    description: "Fast, reliable web apps that work offline and feel like native mobile apps.",
  },
  {
    id: 9,
    imageUrl: "/services/logo.png",
    title: "Web & Mobile Maintenance",
    description:
      "Ongoing support, updates and optimisation to keep your applications running smoothly.",
  },
];

const homeFAQs = [
  {
    id: 1,
    question: "What technologies do you specialize in?",
    answer:
      "We specialise in Flutter and React Native for mobile, React, Next.js and the MERN stack for web, .NET and Electron for desktop, and Node.js APIs behind all of them.",
  },
  {
    id: 2,
    question: "How do you ensure the quality of your work?",
    answer:
      "Every project gets code review, testing and a staging build you can try before release. We follow clean architecture so features stay testable and easy to extend.",
  },
  {
    id: 3,
    question: "Can you customize an existing application?",
    answer:
      "Yes. We regularly take over existing apps to fix bugs, add features, improve performance or rebuild them properly.",
  },
  {
    id: 4,
    question: "Can you help with integrating third-party APIs or services?",
    answer:
      "Yes. We have integrated payments, in-app purchases, social logins, live video, push notifications, Shopify and many cloud services into web and mobile apps.",
  },
  {
    id: 5,
    question: "Do you offer revisions after development?",
    answer:
      "Yes. Revisions are part of every engagement, so the final product matches what we agreed.",
  },
];
// services section Faqs
const servicesFAQs = [
  {
    id: 1,
    question:
      "What technologies do you use for web development?",
    answer:
      "We use React, Next.js, Node.js and the MERN stack for web applications, and WordPress when a content site is the better fit.",
  },
  {
    id: 2,
    question: "Do you develop apps for both iOS and Android?",
    answer:
      "Yes. We build cross-platform apps in Flutter and React Native for iOS and Android, and handle publishing on both stores.",
  },
  {
    id: 3,
    question: "Can you help with existing web or mobile applications?",
    answer:
      "Yes. We maintain, optimise and extend existing web and mobile applications, or rebuild them when that is the better path.",
  },
  {
    id: 4,
    question: "How long does development take?",
    answer:
      "It depends on scope. We give a clear estimate up front, work in milestones and keep you updated throughout.",
  },
  {
    id: 5,
    question: "How can I get started?",
    answer:
      "Send us a message with what you want to build. We reply within 24 hours with questions, a rough plan and an estimate.",
  },
];

const projects = [
  {
    id: 8,
    poster: true,
    images: ["/project/ora_app_01_hero.jpg", "/project/ora_app_02_screens.jpg", "/project/ora_app_03_live.jpg", "/project/ora_app_04_economy.jpg", "/project/ora_app_05_social.jpg"],
    alt: "OraLive",
    title: "OraLive - Live & chat",
    description: "A TikTok-style creator platform: live streams, short videos, stories, chat and an in-app marketplace, with a coin economy that lets fans send gifts and creators withdraw real earnings. Built in Flutter for iOS and Android over a Node.js + Express + MongoDB backend with Socket.IO. Live video runs on LiveKit, and hosts get filters, beauty, background music, guests, PK battles, rankings and post-stream statistics across 76 screens in 12 languages. The app has generated over $30,000 in revenue, validating its product-market fit and engagement-driven monetization model.",
    liveLink: "https://play.google.com/store/apps/details?id=com.lypelive.lypelive",
    iosLink: "https://apps.apple.com/us/app/ora-live/id6755233664",
    technologies: ["Flutter", "LiveKit", "Node.js", "Socket.IO", "MongoDB"]
  },
  {
    id: 15,
    poster: true,
    images: ["/project/druba_app_01_hero.jpg", "/project/druba_app_02_screens.jpg", "/project/druba_app_03_booking.jpg", "/project/druba_app_04_club.jpg", "/project/druba_app_05_bilingual.jpg"],
    alt: "Druba barbershop booking and loyalty app",
    title: "Druba - Barbershop Booking App",
    description: "A branded iOS and Android app for DRUBA, a premium barbershop in Como, Italy, that turns walk-in clients into members. Customers browse grooming rituals with prices and durations, pick their barber, choose a real available slot, pay and receive an instant confirmation. A loyalty layer adds a points wallet, tiered rewards, a VIP room, an inspiration gallery and a store for premium products. Built in Flutter with Clean Architecture, Italian by default with a full English translation, on a Node.js + Fastify + MongoDB API shared with the shop's web CRM and public website.",
    liveLink: "https://play.google.com/store/apps/details?id=com.druba.app",
    iosLink: "https://apps.apple.com/app/id6809565679",
    technologies: ["Flutter", "Node.js", "MongoDB", "Fastify"]
  },
  {
    id: 14,
    poster: true,
    images: ["/project/kg_01_hero.jpg", "/project/kg_02_screens.jpg", "/project/kg_03_economy.jpg", "/project/kg_04_cosmetics.jpg", "/project/kg_05_engagement.jpg"],
    alt: "KG VIP CREW",
    title: "KG VIP CREW",
    description: "Fan community app for a TikTok creator: members chat in real time, earn coins through daily rewards, tasks and a jackpot wheel, unlock cosmetic profile frames and effects, join giveaways for prizes like Amazon, Netflix and gaming consoles, and climb a leaderboard. 50+ screens built in Flutter with Firebase Auth (e-mail, Google, Apple and TikTok login) over a Node.js/Express + MongoDB backend, with Socket.IO for live chat, presence and mentions, in-app purchases with Apple receipt validation, real-time moderation tools and push notifications with deep links.",
    liveLink: "https://play.google.com/store/apps/details?id=com.kgvipcrew.kgvipcrew&hl=en",
    iosLink: "https://apps.apple.com/gr/app/kg-vip-crew/id6757639290",
    technologies: ["Flutter", "Node.js", "Socket.IO", "MongoDB", "Firebase"]
  },
  {
    id: 16,
    poster: true,
    private: true,
    images: ["/project/crm_01_hero_v2.jpg", "/project/crm_02_operations_v2.jpg", "/project/crm_03_reports_v2.jpg", "/project/crm_04_content_v2.jpg"],
    alt: "Druba barbershop CRM dashboard",
    title: "Druba CRM - Barbershop Dashboard",
    description: "Staff-side CRM for the DRUBA barbershop, built as the web twin of the mobile app on the same Fastify + MongoDB API. The owner and barbers get a live overview of customers, today's appointments, staff availability and recent activity, plus appointment history, a filterable calendar, customer profiles with photo galleries, staff ratings and earnings, internal notes with reminders, tags, revenue and bookings reports, an images manager that updates the app instantly, shop settings and a built-in help center. Vite + React 19 + TypeScript with shadcn/ui, Tailwind v4, TanStack Query and Zod, role-gated for admins, in Italian and English.",
    liveLink: "",
    technologies: ["React", "TypeScript", "Tailwind", "MongoDB"]
  },
  {
    id: 17,
    poster: true,
    images: ["/project/druba_web_01_hero.jpg", "/project/druba_web_02_pages.jpg", "/project/druba_web_03_responsive.jpg"],
    alt: "Druba barbershop website",
    title: "Druba - Barbershop Website",
    description: "Public website for the DRUBA barbershop and streetwear brand, built pixel-exact from the client's Figma and made fully fluid for tablets and phones. Home, Shop and Our Story pages with a full-viewport hero, marquee ticker, filterable product catalogue and an editorial long-form story. Next.js 16 App Router, React 19, TypeScript, Tailwind CSS v4 and shadcn/ui with server rendering for SEO, a reduced-motion-safe scroll-reveal system and a booking dialog that opens WhatsApp with a prefilled message or dials the shop.",
    liveLink: "https://druba.com",
    technologies: ["Next.js", "React", "TypeScript", "Tailwind"]
  },
  {
    id: 18,
    poster: true,
    private: true,
    images: ["/project/kgadmin_01_hero_v2.jpg", "/project/kgadmin_02_economy_v2.jpg", "/project/kgadmin_03_catalog_v2.jpg", "/project/kgadmin_04_engagement_v2.jpg"],
    alt: "KG VIP CREW admin dashboard",
    title: "KG VIP CREW - Admin Dashboard",
    description: "Back-office for the KG VIP Crew fan app: one Next.js dashboard that runs the whole community. Admins manage users and badges, coin plans, the lucky wheel, daily rewards and streaks, the cosmetics catalogue, gifts, power-ups, subscriber tiers, giveaways, missions with screenshot-proof review, announcements, push broadcasts, support requests, reports and app settings. Sub-admins get section-level permissions and sign-in is protected by an e-mailed code with trusted-device memory. Next.js 14 with Redux Toolkit over the Express + MongoDB backend shared with the Flutter app, with Socket.IO for live features and a dark theme matching the app's neon design.",
    liveLink: "",
    technologies: ["Next.js", "Redux", "Node.js", "MongoDB"]
  },
  {
    id: 20,
    poster: true,
    private: true,
    images: ["/project/oraadmin_01_hero_v2.jpg", "/project/oraadmin_02_economy_v2.jpg", "/project/oraadmin_03_safety_v2.jpg", "/project/oraadmin_04_settings_v2.jpg"],
    alt: "OraLive admin dashboard",
    title: "OraLive - Admin Dashboard",
    description: "Back-office for the Ora Live platform, built with Next.js 14, Redux Toolkit and Axios over the same Express + MongoDB API as the app. Operators see live and flagged streams in real time, review recordings, monitor chat, and handle reports, support, verification and withdrawal requests. They manage the whole economy of coin plans, gifts, cosmetics, memberships, mystery boxes and tournaments, curate videos, stories, songs, hashtags, banners and shop products, and run security tooling for banned devices, multi-account detection and audit logs. Two-factor admin sign-in with role-based staff permissions, purchase and earnings reports, a push notification composer, and streaming and moderation settings switchable without a deploy.",
    liveLink: "",
    technologies: ["Next.js", "Redux", "Node.js", "MongoDB"]
  },
  {
    id: 10,
    poster: true,
    images: ["/project/pon_01_hero.jpg", "/project/pon_02_flow.jpg", "/project/pon_03_ai.jpg", "/project/pon_04_account.jpg"],
    alt: "Press On Nails",
    title: "Press On Nails",
    description: "An Italian press-on nails brand was losing sales to wrong sizes, so we built a Flutter app that measures every nail with the phone camera and sends the sizes straight to their Shopify store. The customer lays a finger next to any bank card; the camera screen shows a card frame and finger outline, counts down when aligned and captures automatically. A Python/Flask API runs a YOLO computer-vision model, uses the card as a millimetre reference and returns flat and curved nail widths mapped to the shop's size chart. Firebase Auth with Google, Apple and e-mail login, Italian, English and French localisation, GDPR consent flows and Shopify customer metafield sync.",
    liveLink: "https://pressonnails.it/",
    iosLink: "https://pressonnails.it/",
    technologies: ["Flutter", "AI/ML", "Python", "Shopify", "Firebase"]
  },
  {
    id: 19,
    poster: true,
    images: ["/project/pp_web_01_hero.jpg", "/project/pp_web_02_pages.jpg", "/project/pp_web_03_responsive.jpg"],
    alt: "Private Prime asset management website",
    title: "Private Prime - Finance Website",
    description: "Corporate website for Private Prime, an institutional asset-management firm that needed a calm, editorial site that reads like a printed brochure and builds trust in seconds. Home, Services, Company, Contact and Legal pages share one design language: cinematic full-bleed photography, Playfair Display headlines, generous whitespace and a pill navigation that collapses into a drawer on mobile. Built with Nuxt 4, Vue 3 and TypeScript using Nuxt UI, Pinia and @nuxt/image, with server-side rendering for SEO, self-hosted fonts and a lightweight IntersectionObserver-driven scroll-reveal composable for directional fades, staggered children and count-up statistics.",
    liveLink: "",
    technologies: ["Nuxt", "Vue", "TypeScript"]
  },
  {
    id: 1,
    src: "/project/beauty-concept-page.webp",
    alt: "Beauty Concept",
    title: "Beauty Concept",
    description: "UAE's favourite Aesthetic Clinic offering bespoke natural beauty services including plastic surgery, aesthetic treatments, dental care, hair restoration, and health wellness. A comprehensive platform for premium beauty and medical services.",
    liveLink: "https://www.beaute-concept.ae/",
    technologies: ["WordPress"]
  },
  {
    id: 7,
    images: ["/project/safa-banner.jpg", "/project/safaapp1.png", "/project/safaapp2.png", "/project/safaapp3.png", "/project/safaapp4.png", "/project/safaapp5.png"],
    alt: "Safaa's Islamic Affirmations",
    title: "Safaa's Islamic Affirmations",
    description: "A mobile app providing daily Islamic affirmations, prayers, and spiritual guidance. Features beautiful UI, audio recitations, and personalized reminders for spiritual growth.",
    liveLink: "https://play.google.com/store/apps/details?id=com.safaapp.safa_app&hl=en",
    iosLink: "https://apps.apple.com/sg/app/safas-islamic-affirmations/id6745582545",
    technologies: ["Flutter", "Firebase"]
  },
  {
    id: 9,
    images: ["/project/CPBCover.png", "/project/cpbible1.png", "/project/cpbible2.png", "/project/cpbible3.png", "/project/cpbible4.png", "/project/cpbible5.png", "/project/cpbible6.png"],
    detailImages: ["/project/cpbible1.png", "/project/cpbible2.png", "/project/cpbible3.png", "/project/cpbible4.png", "/project/cpbible5.png", "/project/cpbible6.png"],
    video: "/videos/CPB.mp4",
    alt: "Confessional Prayer Bible",
    title: "Confessional Prayer Bible Application",
    description: "Prophesying the Word of God into your Life. The Bible app that helps you pray the Word of God & personalize its divine reality.",
    liveLink: "https://play.google.com/store/apps/details?id=com.cpbible.org",
    iosLink: "https://apps.apple.com/us/app/confessional-prayer-bible/id6468518044",
    technologies: ["Flutter", "PHP"]
  },
  {
    id: 11,
    images: ["/project/iMartCustomerCover.jpg", "/project/iMartCustomer1.png", "/project/iMartCustomer2.png", "/project/iMartCustomer3.png", "/project/iMartCustomer4.png", "/project/iMartCustomer5.png", "/project/iMartCustomer6.png"],
    alt: "iMart Customer",
    title: "iMart Customer",
    description: "A comprehensive e-commerce mobile application designed for customers to browse, shop, and order products from local stores. Features include real-time product search, personalized recommendations, secure payment integration, order tracking, and a seamless shopping experience. Customers can explore multiple stores, compare prices, add items to cart, and get doorstep delivery with just a few taps.",
    liveLink: "https://play.google.com/store/apps/details?id=com.imartstore.customerapp",
    iosLink: "https://apps.apple.com/app",
      technologies: ["Flutter", "Firebase", "PHP"]
  },
  {
    id: 12,
    images: ["/project/iMartStoreCover.png", "/project/iMartstore1.png", "/project/iMartStore2.png", "/project/iMartStore3.png", "/project/iMartStore4.png", "/project/iMartStore5.png", "/project/iMartStore6.png"],
    alt: "iMart Store",
    title: "iMart Store",
    description: "A powerful store management application built for merchants and business owners to manage their inventory, process orders, and track sales in real-time. The app provides comprehensive analytics, inventory management, order processing, customer management, and promotional tools. Store owners can easily add products, manage stock levels, accept orders, and grow their business digitally.",
    liveLink: "https://play.google.com/store/apps/details?id=com.imartstore.imartstore_app",
    iosLink: "https://apps.apple.com/app",
    technologies: ["Flutter", "Firebase", "PHP"]
  },
  {
    id: 13,
    images: ["/project/iMartdelivercover.png", "/project/iMartdelivery1.png", "/project/iMartdelivery2.png", "/project/iMartdelivery3.png", "/project/iMartdelivery4.png", "/project/iMartdelivery5.png", "/project/iMartdelivery6.png"],
    alt: "iMart Delivery",
    title: "iMart Delivery",
    description: "An efficient delivery partner application that connects delivery personnel with customers and stores. Features include real-time order notifications, GPS-based navigation, route optimization, delivery status updates, earnings tracking, and performance analytics. Delivery partners can accept orders, navigate to pickup and drop-off locations, manage multiple deliveries, and maximize their earnings with an intuitive interface.",
    liveLink: "",
    iosLink: "",
    technologies: ["Flutter", "Firebase", "PHP"]
  },
];

const projectImages = projects.map(project => ({ src: project.src, alt: project.alt })); // For backward compatibility

// === Reviews / Testimonials ===
// Real Fiverr reviews. 30 total. 5★ across the board.
const testimonials = [
  {
    id: 1,
    rating: 5,
    timeAgo: "4 months ago",
    quote:
      "Excellent work! The frontend looks clean, modern, and very well-polished. The UI/UX is thoughtfully designed, animations are smooth, and everything fits perfectly with the overall concept. I'm fully satisfied with the result. Highly recommended — great job! 🚀",
    name: "johnyy43",
    country: "Germany",
    countryCode: "DE",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "3 weeks",
  },
  {
    id: 2,
    rating: 5,
    timeAgo: "8 months ago",
    quote: "Great work!",
    name: "spicedshai",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "6 weeks",
  },
  {
    id: 3,
    rating: 5,
    timeAgo: "9 months ago",
    quote: "Awesome job, exactly what I wanted!",
    name: "sucessjilla",
    country: "Sri Lanka",
    countryCode: "LK",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "5 weeks",
  },
  {
    id: 4,
    rating: 5,
    timeAgo: "10 months ago",
    quote: "great work!",
    name: "spicedshai",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "11 days",
  },
  {
    id: 5,
    rating: 5,
    timeAgo: "10 months ago",
    quote:
      "this man is its not just a developer but also a good frind of you he does his job well and with no complains if anyone wants to get his job done hire this man u will not be despondent",
    name: "bleross05",
    country: "Germany",
    countryCode: "DE",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR28k–56k",
    duration: "2 weeks",
  },
  {
    id: 6,
    rating: 5,
    timeAgo: "11 months ago",
    quote: "Excellent work",
    name: "sucessjilla",
    country: "Sri Lanka",
    countryCode: "LK",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "4 days",
  },
  {
    id: 7,
    rating: 5,
    timeAgo: "11 months ago",
    quote:
      "It was great working with Hamza on this app! The results were as discussed! Hamza was swift with response, and revising on work whenever necessary!",
    name: "spicedshai",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR112k–168k",
    duration: "6 weeks",
  },
  {
    id: 8,
    rating: 5,
    timeAgo: "11 months ago",
    quote:
      "Hamza did a fantastic job converting our startup's Figma design into a website application (without functionalities), and we're now continuing to work with him to build out the full site in the second phase. He was highly professional, communicated clearly, and offered valuable suggestions based on his experience.",
    name: "hania_palpals",
    country: "Canada",
    countryCode: "CA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "12 days",
  },
  {
    id: 9,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Very knowledgeable. I'll do business with him again.",
    name: "obaninja",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR112k–168k",
    duration: "6 weeks",
  },
  {
    id: 10,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "amazing experience",
    name: "flli_orsenigo",
    country: "Italy",
    countryCode: "IT",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "4 weeks",
  },
  {
    id: 11,
    rating: 5,
    timeAgo: "1 year ago",
    quote:
      "I hired him for my app development. He did a great job and a quick service. Thank you!",
    name: "royal_estate12",
    country: "Pakistan",
    countryCode: "PK",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "2 days",
  },
  {
    id: 12,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Very Good!",
    name: "nathaliekahya",
    country: "Italy",
    countryCode: "IT",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR56k–112k",
    duration: "7 weeks",
  },
  {
    id: 13,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "would absolutely work again",
    name: "daniyalahmadka",
    country: "Pakistan",
    countryCode: "PK",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR28k–56k",
    duration: "2 weeks",
  },
  {
    id: 14,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Ottimo lavoro, assolutamente consigliato.",
    name: "nathaliekahya",
    country: "Italy",
    countryCode: "IT",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "2 weeks",
  },
  {
    id: 15,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Great work, as always",
    name: "maituz",
    country: "South Africa",
    countryCode: "ZA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "5 days",
  },
  {
    id: 16,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "He is a reliable guy",
    name: "maituz",
    country: "South Africa",
    countryCode: "ZA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
  {
    id: 17,
    rating: 5,
    timeAgo: "1 year ago",
    quote:
      "I have to say one thing for sure: this is the only guy you need to publish your app properly. He is professional, polite, and definitely knows his work. I'm going to work with you again for sure! Thank you stay blessed.",
    name: "bizzinnova",
    country: "Pakistan",
    countryCode: "PK",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "9 days",
  },
  {
    id: 18,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Great work as always!",
    name: "ianandela",
    country: "South Africa",
    countryCode: "ZA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
  {
    id: 19,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Great work as always!",
    name: "ianandela",
    country: "South Africa",
    countryCode: "ZA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
  {
    id: 20,
    rating: 5,
    timeAgo: "1 year ago",
    quote:
      "The most trustable person ever, I hired a guy on Fivver but he was not professional but this guy is professional, and trustworthy.",
    name: "gr8zaheer",
    country: "Pakistan",
    countryCode: "PK",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR28k–56k",
    duration: "2 weeks",
  },
  {
    id: 21,
    rating: 5,
    timeAgo: "1 year ago",
    quote: "Amazing guy and has been a pleasure working with him! 🙌👌",
    name: "ianandela",
    country: "South Africa",
    countryCode: "ZA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "7 days",
  },
  {
    id: 22,
    rating: 5,
    timeAgo: "1 year ago",
    quote:
      "Rating: ⭐️⭐️⭐️⭐️⭐️ I had a great experience working with him on resolving a Flutter bug. Their expertise was evident, as they quickly identified the issue and proposed an effective solution. Throughout the project, they maintained clear communication, demonstrated excellent problem-solving skills.",
    name: "dmcgravey",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
  {
    id: 23,
    rating: 5,
    timeAgo: "2 years ago",
    quote: "Good communication and he executed the job.",
    name: "devineproductio",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
  {
    id: 24,
    rating: 5,
    timeAgo: "2 years ago",
    quote: "Great Experience",
    name: "sifodev",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "2 weeks",
  },
  {
    id: 25,
    rating: 5,
    timeAgo: "2 years ago",
    quote: "Good job bro 😎",
    name: "devlopsf23",
    country: "Algeria",
    countryCode: "DZ",
    role: "Technical Support",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
  {
    id: 26,
    rating: 5,
    timeAgo: "2 years ago",
    quote: "good seller, highly recommended",
    name: "donkanda",
    country: "Morocco",
    countryCode: "MA",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "4 days",
  },
  {
    id: 27,
    rating: 5,
    timeAgo: "2 years ago",
    quote:
      "Amazing work from Hamza! he fixed the previous issue the past developer created and published the app on time.",
    name: "maituz",
    country: "South Africa",
    countryCode: "ZA",
    role: "Technical Support",
    source: "Fiverr",
    price: "PKR14k",
    duration: "4 days",
  },
  {
    id: 28,
    rating: 5,
    timeAgo: "2 years ago",
    quote: "Work done as asked.",
    name: "cornerofluke",
    country: "Italy",
    countryCode: "IT",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k–28k",
    duration: "4 weeks",
  },
  {
    id: 29,
    rating: 5,
    timeAgo: "2 years ago",
    quote:
      "Very helpful and attentive to customer needs. Highly recommended",
    name: "cornerofluke",
    country: "Italy",
    countryCode: "IT",
    role: "iOS App Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "3 weeks",
  },
  {
    id: 30,
    rating: 5,
    timeAgo: "2 years ago",
    quote: "good work good communication",
    name: "amra009",
    country: "United States",
    countryCode: "US",
    role: "Cross-Platform Development",
    source: "Fiverr",
    price: "PKR14k",
    duration: "1 day",
  },
];

// Work history, newest first. `current` roles get the live "Now" marker.
const experience = [
  {
    id: 1,
    role: "Lead Software Engineer",
    company: "Vision Scale Labs",
    link: "https://visionscale-labs.com",
    period: "2025 – Present",
    type: "Full-time · Remote",
    current: true,
    summary:
      "Lead the engineering team and own client projects from planning through launch.",
    highlights: [
      "Lead a remote team of developers through sprint planning, code reviews and on-time releases",
      "Turn client requirements into technical plans, estimates and delivery timelines",
      "Ship mobile apps, web platforms and admin dashboards to the App Store, Google Play and the web",
      "Built and launched the company website",
    ],
  },
  {
    id: 2,
    role: "Software Consultant",
    company: "Independent consultancy",
    period: "2022 – Present",
    type: "Karachi · Clients worldwide",
    current: true,
    summary:
      "Design, build and ship web, mobile and desktop products for clients, with a senior team behind the larger builds.",
    highlights: [
      "30+ projects shipped for clients in 9 countries",
      "12 app releases on the App Store and Google Play",
      "30 five-star reviews on Fiverr",
      "OraLive, a live-streaming app we built, has generated $30K+ in revenue",
    ],
  },
  {
    id: 3,
    role: "Mobile Application Developer",
    company: "CYBRNODE",
    period: "Apr 2023 – Jul 2023",
    type: "Internship",
    current: false,
    summary:
      "Built Flutter features for cross-platform mobile apps in an Agile team.",
    highlights: [
      "Worked in Agile sprints with the wider product team",
      "Solved technical problems and shipped features for iOS and Android",
    ],
  },
];

export {
  ContactUs,
  experience,
  servicesData,
  homeFAQs,
  servicesFAQs,
  projectImages,
  projects,
  servicesDataHome,
  testimonials,
};
